import apiClient from '../apiClient';
import { POST_UNLOCK_USER_URL } from '../apiUrl';

const postUnlockUserApi = id => {
  return apiClient.post(POST_UNLOCK_USER_URL(id));
};

export default postUnlockUserApi;
